import { useMemo } from 'react';
import { useAppSelector } from 'store';
import { selectUser } from 'store/user';
import { useRoomHost } from 'hooks';
import { useLocalStorageBoolean } from 'hooks/useLocalStorageBoolean/useLocalStorageBoolean';

export function useCanShowRecordingButton(): boolean {
  const { isHost } = useRoomHost();
  const user = useAppSelector(selectUser);

  const aiCreditsCount = user?.clinicUser?.aiCreditsCount ?? 0;

  const promptAtStart = useLocalStorageBoolean('promptAiNotesAtStart');
  const groupCallsEnabled = useLocalStorageBoolean('groupCallsEnabled');

  return useMemo(() => {
    if (!isHost) return false;

    // 🔑 Hard override
    if (groupCallsEnabled) return true;

    return aiCreditsCount > 0 && promptAtStart;
  }, [isHost, aiCreditsCount, promptAtStart, groupCallsEnabled]);
}
